import { createContext, useCallback, useContext, useMemo, useState } from "react";
import { CheckCircle2, X, XCircle } from "lucide-react";

const ToastContext = createContext(null);
export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);
  const remove = useCallback((id) => setToasts((current) => current.filter((toast) => toast.id !== id)), []);
  const showToast = useCallback((message, type = "success") => { const id = Date.now() + Math.random(); setToasts((current) => [...current, { id, message, type }]); setTimeout(() => remove(id), 4000); }, [remove]);
  const value = useMemo(() => ({ showToast }), [showToast]);
  return <ToastContext.Provider value={value}>{children}<div className="fixed right-4 top-4 z-[100] space-y-3" aria-live="polite">{toasts.map((toast) => <div key={toast.id} className={`flex min-w-72 items-center gap-3 rounded-xl border p-4 shadow-2xl ${toast.type === "error" ? "border-red-700 bg-red-950 text-red-100" : "border-emerald-700 bg-emerald-950 text-emerald-100"}`}>{toast.type === "error" ? <XCircle/> : <CheckCircle2/>}<span className="flex-1 text-sm font-bold">{toast.message}</span><button aria-label="Cerrar notificacion" onClick={() => remove(toast.id)}><X size={16}/></button></div>)}</div></ToastContext.Provider>;
}
export const useToast = () => useContext(ToastContext);



